export const isObjectEmpty = someObject =>
    Object.keys(someObject).length === 0 && someObject.constructor === Object;

export default isObjectEmpty;
